import { useEffect, useState } from "react";
import { CardDetails } from "../../../../common/components/CardDetails/CardDetails"
import style from "./style.module.scss"
import { BagService } from "../../../../common/services/merchandise_request";
import { HttpStatusCode } from "axios";
import { Loader } from "../../../../common/components/Loader/Loader";
import { useLocation, useParams } from "react-router";

type storageBagDetailType = {
  initialValue: any
}

const StorageBagDetail = ( {initialValue}: storageBagDetailType) => {

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { id : locationId } = useParams();
  const [data, setData] = useState<any>({});

  const id = initialValue?.["@id"].split("/").pop();

  useEffect(() => {
    id && getStorageBag(id);
  }, [initialValue]);

  const getStorageBag = async (id: number) => {
    try {
      setIsLoading(true);
      const res = await BagService.getBagById(id);
      if (res?.status === HttpStatusCode.Ok) {
        setData(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

const renderValue = (value : any /* string | number | boolean */) => {
  return value ? value : "-";
}; 

const matchingTonnage = data?.storageLoadData?.find((item: any) => {
  const storageId = item.storage?.["@id"]?.split("/").pop();
  return storageId == locationId;
});

  return (
    <div>
      <Loader isLoading={isLoading}/>
      <CardDetails className="d-flex gap-2 flex-column">
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Désignation : </span>
                <span className={style.details__value}>{renderValue(data?.designation)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>N° de Lot : </span>
                <span className={style.details__value}>{renderValue(data?.batchNumber)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Marque : </span>
                <span className={style.details__value}>{renderValue(data?.brand)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Contenu : </span>
                <span className={style.details__value}>{renderValue(data?.content)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Conditionnement : </span>
                <span className={style.details__value}>{renderValue(data?.packaging)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Poids Net (T) : </span>
                <span className={style.details__value}>{renderValue(data?.netWeight)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Tonnage (T) : </span>
                <span className={style.details__value}>{renderValue(matchingTonnage?.tonnageInStock)}</span>

              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Quantité : </span>
                <span className={style.details__value}>{renderValue(data?.qty)}</span>
              </div>
            </CardDetails>
    </div>
  )
}

export default StorageBagDetail